import { Flex } from '@ui-library/misc';
import { useCloudSourceInfo } from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import CloudSourceStats from '@stores/cloudSourcesInfo/cloudSourcesStats';
import CloudSourceStatus from '@stores/cloudSourcesInfo/cloudSourceStatus';
import StartSyncButton from '../StartSyncButton';
import React from 'react';
import CloudSourceRun from './cloudSourceRun';

interface StatusProps {
  isAdmin: boolean;
}

const CloudSourceStatusTab = ({ isAdmin }: StatusProps) => {
  const { lastRunData } = useCloudSourceInfo();
  const data = lastRunData?.filter((d) => !!d.taskRunId);
  return (
    <div>
      <Flex centered>
        <div>
          <CloudSourceStatus />
          <CloudSourceStats />
        </div>
        {isAdmin && (
          <div style={{ marginLeft: 'auto' }}>
            <StartSyncButton isAdmin={isAdmin} />
          </div>
        )}
      </Flex>
      {(data && data.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <CloudSourceRun data={data} />
        </div>
      )) ||
        null}
    </div>
  );
};

export default CloudSourceStatusTab;
